// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transport-list-container {
  padding: 12px 6px 6px;
  border: 1px solid var(--eta-border-color);
  border-radius: 1rem;
}
.transport-list-container .name {
  font-size: 22px;
  font-weight: 500;
  color: var(--eta-color-theme);
  margin-block-end: 6px;
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  align-items: center;
}
.transport-list-container .name .icon {
  display: block;
  width: fit-content;
  margin: 0;
}
.transport-list-container .name .icon svg {
  display: block;
  max-height: 22px;
  width: fit-content;
}
/*# sourceMappingURL=TransportList.css.map */`, "",{"version":3,"sources":["webpack://./TransportList.less","webpack://./src/components/TransportList/TransportList.less"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,yCAAA;EACA,mBAAA;ACCJ;ADJA;EAMQ,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;ACCR;ADdA;EAgBY,cAAA;EACA,kBAAA;EACA,SAAA;ACCZ;ADnBA;EAqBgB,cAAA;EACA,gBAAA;EACA,kBAAA;ACChB;AACA,4CAA4C","sourcesContent":[".transport-list-container {\n    padding: 12px 6px 6px;\n    border: 1px solid var(--eta-border-color);\n    border-radius: 1rem;\n\n    .name {\n        font-size: 22px;\n        font-weight: 500;\n        color: var(--eta-color-theme);\n        margin-block-end: 6px;\n        display: flex;\n        flex-flow: row nowrap;\n        gap: 12px;\n        align-items: center;\n\n        .icon {\n            display: block;\n            width: fit-content;\n            margin: 0;\n\n            svg {\n                display: block;\n                max-height: 22px;\n                width: fit-content;\n            }\n        }\n    }\n}",".transport-list-container {\n  padding: 12px 6px 6px;\n  border: 1px solid var(--eta-border-color);\n  border-radius: 1rem;\n}\n.transport-list-container .name {\n  font-size: 22px;\n  font-weight: 500;\n  color: var(--eta-color-theme);\n  margin-block-end: 6px;\n  display: flex;\n  flex-flow: row nowrap;\n  gap: 12px;\n  align-items: center;\n}\n.transport-list-container .name .icon {\n  display: block;\n  width: fit-content;\n  margin: 0;\n}\n.transport-list-container .name .icon svg {\n  display: block;\n  max-height: 22px;\n  width: fit-content;\n}\n/*# sourceMappingURL=TransportList.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
